/**
 * Created by Jie Gao on 2018-11-08.
 */
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";


export interface ButtonLike {
    enabled:boolean;
    click:() => void;
}

export interface IButtonTextures {
    readonly deactive:PIXI.Texture | (PIXI.Texture[]);
    readonly idle:PIXI.Texture | (PIXI.Texture[]);
    readonly over:PIXI.Texture | (PIXI.Texture[]);
    readonly down:PIXI.Texture | (PIXI.Texture[]);
    readonly disabled:PIXI.Texture | (PIXI.Texture[]);
}

export enum ButtonState {
    disabled = 0,
    deactive,
    idle,
    over,
    down
}

export class StarStruckButton extends PIXI.Sprite implements ButtonLike {

    private _deactiveState:TimelineSprite;
    private _idleState:TimelineSprite;
    private _disabledState:TimelineSprite;
    private _currentState:TimelineSprite;
    private _overState:TimelineSprite;
    private _downState:TimelineSprite;
    private _onClickedCallback:() => void;
    protected _enabled:boolean;

    public set enabled(value:boolean) {
        if(this._enabled != value) {
            this._enabled = value;
            this.setState(this._enabled ? ButtonState.idle : ButtonState.disabled);
            this.interactive = value;
            this.buttonMode = value;
        }
    }

    public get enabled():boolean {
        return this._enabled;
    }

    // @ts-ignore
    public get width():number {
        return this._currentState.width;
    }

    constructor(textures:IButtonTextures, onClickedCallback:() => void, sourceFPS:number = 30) {
        super();
        this._idleState = this.createState(textures.idle, sourceFPS);
        this._disabledState = this.createState(textures.disabled, sourceFPS);
        this._deactiveState = this.createState(textures.deactive, sourceFPS);
        this._overState = this.createState(textures.over, sourceFPS);
        this._downState = this.createState(textures.disabled, sourceFPS);
        this._onClickedCallback = onClickedCallback;
        this.init();
    }

    private createState(textureConfig:PIXI.Texture | PIXI.Texture[], sourceFPS:number):TimelineSprite {
        let state:TimelineSprite;
        if(Array.isArray(textureConfig)) {
            state = new TimelineSprite(textureConfig, sourceFPS);
        } else {
            state = new TimelineSprite([textureConfig], sourceFPS);
        }

        this.addChild(state);
        state.visible = false;
        state.anchor.set(0.5, 0.5);

        return state;
    }

    public setState(state:ButtonState, autoPlay:boolean = true):void {
        this._idleState.hide();
        this._disabledState.hide();
        this._deactiveState.hide();
        this._overState.hide();
        this._downState.hide();
        switch(state) {
            case ButtonState.disabled:
                this._currentState = this._disabledState;
                break;
            case ButtonState.idle:
                this._currentState = this._idleState;
                break;
            case ButtonState.deactive:
                this._currentState = this._deactiveState;
                break;
            case ButtonState.over:
                this._currentState = this._overState;
                break;
            case ButtonState.down:
                this._currentState = this._downState;
                break;
            default:
                debugger;
                throw new Error(`Button.setState(): Illegal button state ${state}`);
        }

        this._currentState.getAnimation(autoPlay ? [0] : [0, 0]);
        this._currentState.show();
    }

    protected init():void {
        // this._enabled = true;
        this.anchor.set(0.5, 0.5);

        this.on('pointerdown', this.onDown);
        this.on('pointerout', this.onIdle);
        this.on('pointerover', this.onOver);
        this.on('pointertap', this.onUp);

        this.setState(ButtonState.idle);
    }

    protected onIdle():void {
        if(!this._enabled) {
            return;
        }
        this.setState(ButtonState.idle);
    }

    protected onOver():void {
        if(!this._enabled) {
            return;
        }
        this.setState(ButtonState.over);
    }

    protected onDown():void {
        if(!this._enabled) {
            return;
        }
        this.setState(ButtonState.down);
    }

    protected onUp():void {
        if(!this._enabled) {
            return;
        }
        this._onClickedCallback();
    }

    public click():void {
        this.onUp();
    }
}